import HistorySVG from "@design-system/ui-icons/vanilla/History"
import { createIcon } from "../createIcon"

export const HistoryIcon = createIcon(HistorySVG)
